/* istanbul ignore file */
export default {
  loading: 'Loading',
  noRowsToShow: 'There is no content',
  pinColumn: 'Pin Column'
};
